import AppContext from "@/AppContext";
import Layout from "@/components/elements/Layout";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import useAuth from "@/hooks/auth";
import { getStartupDetail, searchStartupAll } from "@/services/api/Startup";
import {
  createStripeCheckout,
  updateUserSubscription,
} from "@/services/api/Stripe";
import { checkCoupon } from "@/services/api/User";
import { Check, MagnifyingGlass, X } from "@phosphor-icons/react";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import Image from "next/legacy/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import availablePricesDev from "@/hooks/availablePrices.dev";
import availablePricesProd from "@/hooks/availablePrices.prod";
import { updateSession } from "@/services/api/Stripe";
import productsDev from "@/hooks/products.dev";
import productsProd from "@/hooks/products.prod";
import { convertStripeAmount } from "@/utils/currency";

const wait = () => new Promise((resolve) => setTimeout(resolve, 1000));

const stripePromise = loadStripe(
  process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY
);

const startupBenefits = [
  "Register Your Startup ",
  "Get Researcher All-Access Pass",
  "Get unlimited access to all our News, Spotlights, Infobytes and Videos",
  "Get Full Access to our Database of Investors",
  "Get Full Access to our Database of Startups",
  "Get Full Access to Read Special Reports",
  "Download PDF version of our Special Reports",
  "Like & Save your favorite content, startups and investors",
  "Subscribe to Our Weekly Newsletter",
  "Get access to the latest features and specialized content",
];

const products = process.env.ENV !== "production" ? productsDev : productsProd;

const Pricing = ({ userLocation, priceData, priceIds, currencyCode, ip }) => {
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedResult, setSelectedResult] = useState(null);
  const [claimedStartup, setClaimedStartup] = useState(null);
  const { user } = useAuth({ middleware: "auth" }); // first_name, last_name, job_title, industry, email
  const context = useContext(AppContext);
  const { planSubscription, loading } = context.state;
  console.log(planSubscription);
  const router = useRouter();

  const [searchResults, setSearchResults] = useState([]);
  const [input, setInput] = useState("");
  const [inputCoupon, setInputCoupon] = useState("");
  const [coupon, setCoupon] = useState(null);
  const [couponError, setCouponError] = useState(false);
  const [couponErrorProduct, setCouponErrorProduct] = useState(false);
  const [loadingCheck, setloadingCheck] = useState(false);

  const handleChangeSearch = async (e) => {
    setInput(e.target.value);
    if (e.target.value.length >= 3) {
      const response = await searchStartupAll({
        params: {
          keyword: e.target.value,
        },
      });
      setSearchResults(response.data.map((r) => r.searchable));
    } else {
      setSearchResults([]);
    }
  };

  const handleSubscriptionStartupExist = (selectedStartup) => {
    setSelectedResult(selectedStartup);
    setIsOpen(true);
  };

  const handleSubscriptionStartupNotExist = () => {
    setSelectedResult(null);
    setIsOpen(true);
  };

  const handleSubscription = async (event) => {
    setIsOpen(false);
    setOpen(true);
    // Get Stripe.js instance
    const stripe = await stripePromise;

    if (
      planSubscription &&
      planSubscription.is_content_plan &&
      planSubscription.subscription_detail.status === "trialing"
    ) {
      // on trial period
      try {
        const response = await updateUserSubscription(
          planSubscription.subscription_detail.id,
          {
            si_id: planSubscription.subscription_detail.items.data[0].id,
            price_id: priceData["Startup Registration"].id,
          }
        );
        setOpen(false);
        toast.success(
          "Congratulation! You have been successfully upgraded to Startup Registration plan."
        );
        setTimeout(() => {
          location.href = "/account/plan";
        }, 300);
      } catch (error) { }
    } else if (planSubscription && planSubscription.is_content_plan) {
      // upgrade
    } else {
      // subscribe
      // Call your backend to create the Checkout Session
      const response = await createStripeCheckout({
        userEmail: user.email,
        priceId: priceData["Startup Registration"].id, // yearly
        is_exist: selectedResult ? true : false,
        startup_id: selectedResult ? selectedResult.id : null,
        initial_input: input,
        type: "startup",
        coupon_id: coupon ? coupon.id : null,
      });

      const session = response.data;

      console.log(session);

      // When the customer clicks on the button, redirect them to Checkout.
      const result = await stripe.redirectToCheckout({
        sessionId: session.id,
      });

      if (result.error) {
        // If `redirectToCheckout` fails due to a browser or network
        // error, display the localized error message to your customer
        // using `result.error.message`.
        alert(result.error.message);
      }
    }
  };

  const handleCheckCoupon = async () => {
    if (!inputCoupon) return;
    if (loadingCheck || coupon) return;
    setCouponError(false);
    setCouponErrorProduct(false);
    setCoupon(null);
    setloadingCheck(true);

    try {
      const res = await checkCoupon(inputCoupon);

      if (res.data.redeem_by && Date.now() > res.data.redeem_by * 1000) {
        setCouponError(true);
        setloadingCheck(false);
        return;
      }

      if (res.data.applies_to && res.data.applies_to.products) {
        if (res.data.applies_to.products.includes(products["Startup Registration"])) {
          setCoupon(res.data);
        } else {
          setCouponErrorProduct(true);
        }
      } else {
        setCoupon(res.data);
      }

      setloadingCheck(false);
    } catch (error) {
      console.log(error);
      setCouponError(true);
      setloadingCheck(false);
      setCoupon(null);
      setCouponErrorProduct(false);
    }
  };

  const onRemoveCoupon = () => {
    setInputCoupon("");
    setCoupon(null);
    setCouponErrorProduct(false);
  };

  const onCancel = () => {
    setIsOpen(false);
    setInputCoupon("");
    setCoupon(null);
    setCouponErrorProduct(false);
  };

  const handleCouponChange = (e) => {
    setInputCoupon(e.target.value);
    setCouponError(false);
    setCouponErrorProduct(false);
  };

  const getStartup = async (startupId) => {
    const res = await getStartupDetail(startupId);
    const data = res?.data;
    if (data) {
      setClaimedStartup(data);
    }
  };

  useEffect(() => {
    if (router.query.startup) {
      getStartup(router.query.startup);
    }
  }, [router.query]);

  const continueClaim = async () => {
    if (router.query.startup) {
      const res = await updateSession(planSubscription.session_detail.id, {
        startup_id: router.query.startup,
      });
      location.href = "/startups/register?step=2";
    } else {
      router.push("/startups/register?step=2");
    }
  };

  return (
    <Layout title={"Startup Registration Pricing | Lucidity Insights"}>
      <div className='relative isolate'>
        <svg
          className='absolute inset-0 -z-10 h-full w-full stroke-white [mask-image:radial-gradient(100%_100%_at_top_right,rgba(255,255,255,0.3),transparent)]'
          aria-hidden='true'
        >
          <defs>
            <pattern
              id='83fd4e5a-9d52-42fc-97b6-718e5d7ee527'
              width={200}
              height={200}
              x='50%'
              y={-1}
              patternUnits='userSpaceOnUse'
            >
              <path d='M100 200V.5M.5 .5H200' fill='none' />
            </pattern>
          </defs>
          <rect
            width='100%'
            height='100%'
            strokeWidth={0}
            fill='url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)'
          />
        </svg>
        <div className='px-4 py-16 mx-auto lg:py-24 max-w-7xl lg:flex lg:items-center lg:gap-x-20'>
          <div className='lg:flex-1'>
            <h1 className='text-4xl font-bold tracking-tight sm:text-6xl'>
              Plug Yourself into the Regional Startup Ecosystem
            </h1>

            <p className='mt-4 text-base lg:text-lg lg:mt-6'>
              {`Keep up and make sure you're in the know of the who's who and
              what's what of the Middle East & Africa's startup ecosystems by
              registering your startup now.`}
            </p>
            <div className='mt-4 lg:hidden'>
              {currencyCode !== "USD" && (
                <div className='flex items-center gap-2 mb-2 font-medium'>
                  <p className='text-lg'>We have a special price for</p>
                  <p className='text-2xl'>
                    {userLocation.country?.countryFlagEmoji}
                  </p>
                </div>
              )}
              <div className='relative z-10 bg-white shadow-xl text-background rounded-2xl ring-1 ring-gray-900/10 xl:mb-10'>
                <div className='p-6 lg:p-8'>
                  {!planSubscription?.is_startup_plan ? (
                    <div className='flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between lg:flex-col lg:items-stretch'>
                      <div className='flex flex-col gap-x-4'>
                        <p className='text-4xl font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-br from-yellow-1 to-red-1'>
                          {currencyCode === "USD" ? "$" : currencyCode + " "}
                          {convertStripeAmount(
                            priceData["Startup Registration"].unit_amount,
                            currencyCode
                          ).toLocaleString()}
                        </p>
                        <div className='mt-1 text-sm'>
                          {/* Payment frequency, update based on frequency toggle state */}
                          <p className='inline-block mr-1.5 text-gray-500'>
                            Billed annually
                          </p>
                          <span className='text-xs font-medium text-gray-500'>
                            ({currencyCode === "USD" ? "$" : currencyCode + " "}
                            {Math.round(
                              priceData["Startup Registration"].unit_amount /
                              1200
                            ).toLocaleString()}{" "}
                            monthly)
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <p className='font-semibold'>Your Plan: </p>
                      <p className='text-2xl font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-br from-yellow-1 to-red-1'>
                        Startup Registration
                      </p>
                    </div>
                  )}
                  <div className='flow-root pt-3 mt-3 border-t sm:mt-4 sm:pt-4 border-black/10'>
                    <ul
                      role='list'
                      className='-my-2 text-sm leading-6 text-gray-600 border-t divide-y lg:border-t-0 divide-gray-900/5 border-gray-900/5'
                    >
                      {startupBenefits.map((benefit, index) => (
                        <li
                          key={`benefit-${index}`}
                          className='flex py-2 gap-x-3'
                        >
                          <svg
                            className='flex-none w-5 h-6 text-orange-1'
                            viewBox='0 0 20 20'
                            fill='currentColor'
                            aria-hidden='true'
                          >
                            <path
                              fillRule='evenodd'
                              d='M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z'
                              clipRule='evenodd'
                            />
                          </svg>
                          {benefit}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {planSubscription &&
              planSubscription?.is_startup_plan &&
              !router.query.startup ? (
              <div className='pt-4 mt-10 mb-6 -my-3 divide-y divide-dashed divide-white/10'>
                <Button
                  onClick={() => router.push("/account/startup")}
                  className='text-white bg-gradient-to-r from-slate-600 to-slate-500 hover:text-slate-300'
                >
                  Go to My Startup
                </Button>
              </div>
            ) : (
              <div className='relative max-w-xl mt-7 lg:mt-9'>
                {!claimedStartup && (
                  <MagnifyingGlass
                    size={20}
                    weight='bold'
                    className='absolute z-10 left-4 text-background top-[18px]'
                  />
                )}
                {!claimedStartup && (
                  <Input
                    type='text'
                    placeholder='Type your Startup Name or Website'
                    className='pl-12 text-sm font-medium bg-white border-white shadow lg:text-base text-background h-14 pr-28'
                    onChange={handleChangeSearch}
                  />
                )}
                <AlertDialog open={isOpen} onClose={() => setIsOpen(false)}>
                  {!claimedStartup && (
                    <AlertDialogTrigger>
                      <Button
                        onClick={handleSubscriptionStartupNotExist}
                        disabled={
                          input.length < 3 ||
                          searchResults.find(
                            (s) => s.name.toLowerCase() == input.toLowerCase()
                          )
                        }
                        className='absolute text-white top-2 right-2 bg-background hover:bg-gray-800'
                      >
                        {searchResults.length > 0 ? (
                          <span>
                            Go with{" "}
                            <span className='font-bold underline'>{input}</span>
                          </span>
                        ) : (
                          <span>Proceed</span>
                        )}
                      </Button>
                    </AlertDialogTrigger>
                  )}
                  <AlertDialogContent className='overflow-x-auto text-gray-800 bg-white'>
                    <AlertDialogHeader>
                      <AlertDialogTitle className='mb-4'>
                        You are about to{" "}
                        {planSubscription?.is_content_plan
                          ? "upgrade"
                          : "subscribe"}{" "}
                        to the Startup Registration Plan!
                      </AlertDialogTitle>
                      {!planSubscription && (
                        <div className='mb-2'>
                          <p className='mb-2 text-sm'>Coupon Code (Optional)</p>
                          <div className='flex justify-between gap-4'>
                            <Input
                              onChange={(e) => setInputCoupon(e.target.value)}
                              className='text-gray-800 bg-white'
                              disabled={coupon}
                              value={inputCoupon}
                              onBlur={() => setCouponError(false)}
                            />
                            <Button
                              onClick={handleCheckCoupon}
                              className={`${coupon
                                  ? "bg-green-500 hover:bg-green-500 cursor-default"
                                  : "bg-gray-800 hover:bg-gray-500"
                                } text-white w-1/3`}
                            >
                              {loadingCheck
                                ? "Checking..."
                                : coupon
                                  ? "Applied"
                                  : "Apply"}
                            </Button>
                          </div>
                          {coupon && (
                            <div
                              onClick={onRemoveCoupon}
                              className='text-sm text-red-500 cursor-pointer'
                            >
                              Remove
                            </div>
                          )}
                        </div>
                      )}
                      {couponError && (
                        <p className='text-sm text-red-500'>
                          This Coupon does not exist or has expired.
                        </p>
                      )}
                      <div className='p-4 mt-2 rounded-lg bg-slate-100'>
                        <div className='flex justify-between mb-2 font-semibold'>
                          <p>Price</p>
                          <p>
                            {currencyCode !== "USD" ? currencyCode + " " : "$"}
                            {(
                              priceData["Startup Registration"].unit_amount /
                              100
                            ).toLocaleString("en", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                        </div>
                        {coupon && (
                          <div className=''>
                            <div className='flex justify-between'>
                              <p>
                                Coupon{" "}
                                <span className='text-sm'>({coupon.id})</span>
                              </p>
                              <p>
                                -
                                {currencyCode !== "USD"
                                  ? currencyCode + " "
                                  : "$"}
                                {coupon.percent_off
                                  ? Math.round(
                                    (coupon.percent_off / 10000) *
                                    priceData["Startup Registration"]
                                      .unit_amount
                                  ).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })
                                  : (coupon.amount_off / 100).toLocaleString(
                                    "en",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                              </p>
                            </div>
                            <div className='flex justify-between mt-2 font-bold'>
                              <p>Total</p>
                              <p>
                                {currencyCode !== "USD"
                                  ? currencyCode + " "
                                  : "$"}
                                {coupon.percent_off
                                  ? (
                                    priceData["Startup Registration"]
                                      .unit_amount /
                                    100 -
                                    Math.round(
                                      (coupon.percent_off / 10000) *
                                      priceData["Startup Registration"]
                                        .unit_amount
                                    )
                                  ).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })
                                  : (
                                    priceData["Startup Registration"]
                                      .unit_amount /
                                    100 -
                                    coupon.amount_off / 100
                                  ).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </AlertDialogHeader>
                    <AlertDialogFooter className='flex sm:justify-between'>
                      <AlertDialogCancel
                        onClick={onCancel}
                        className='hover:bg-slate-100'
                      >
                        Cancel
                      </AlertDialogCancel>
                      <AlertDialogAction
                        onClick={handleSubscription}
                        className='text-white bg-gray-800 hover:bg-gray-500'
                      >
                        {planSubscription?.is_content_plan
                          ? "Upgrade"
                          : "Go to Payment"}
                      </AlertDialogAction>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialog>

                <Dialog open={open} onOpenChange={setOpen}>
                  <DialogContent>
                    <DialogHeader>
                      <DialogTitle>Loading Payment..</DialogTitle>
                      <DialogDescription>
                        <div className='mt-2'>
                          Please wait...you will be redirected to the secure
                          payment page.
                        </div>
                      </DialogDescription>
                    </DialogHeader>
                  </DialogContent>
                </Dialog>
              </div>
            )}
            {claimedStartup ? (
              <div className='flex items-start justify-between py-4'>
                <div className='flex items-start space-x-4'>
                  <div className='w-[50px] lg:w-[60px] rounded-lg relative overflow-hidden aspect-square'>
                    {claimedStartup.logo_url &&
                      claimedStartup.logo_url.includes("http") && (
                        <Image
                          src={claimedStartup.logo_url}
                          layout={"fill"}
                          objectFit={"cover"}
                          alt='Image'
                        />
                      )}
                  </div>
                  <div className='flex flex-col'>
                    <p className='text-lg font-bold text-white lg:text-2xl'>
                      {claimedStartup.name}
                    </p>
                    {claimedStartup.website && (
                      <Link
                        legacyBehavior
                        href={claimedStartup.website}
                        passHref
                      >
                        <a
                          target='_blank'
                          rel='noreferrer'
                          className='lg:mt-1.5 text-[10px] lg:text-xs font-medium underline opacity-50'
                        >
                          {claimedStartup.website}
                        </a>
                      </Link>
                    )}
                  </div>
                </div>
                {!planSubscription ||
                  (!planSubscription?.is_startup_plan &&
                    !planSubscription?.has_startup) ? (
                  <Button
                    className='mt-1'
                    size='sm'
                    onClick={
                      claimedStartup.owner_id
                        ? () =>
                          router.push(
                            `/startups/${claimedStartup.slug}-${claimedStartup.id}`
                          )
                        : () => handleSubscriptionStartupExist(claimedStartup)
                    }
                  >
                    Claim Now
                  </Button>
                ) : (
                  planSubscription &&
                  planSubscription?.is_startup_plan &&
                  !planSubscription?.has_startup && (
                    <Button className='mt-1' size='sm' onClick={continueClaim}>
                      Claim Now
                    </Button>
                  )
                )}
              </div>
            ) : searchResults.length === 0 && input.length >= 3 ? (
              <div className='flex items-center space-x-2'>
                <span className='inline-flex items-center justify-center w-5 h-5 text-white bg-green-600 rounded-full'>
                  <Check className='text-xs' weight='bold' />
                </span>
                <span className='text-sm font-medium text-green-500'>
                  You can use this name!
                </span>
              </div>
            ) : input.length >= 3 &&
              searchResults.find(
                (s) => s.name.toLowerCase() == input.toLowerCase()
              ) ? (
              <div className='flex items-center space-x-2'>
                <span className='inline-flex items-center justify-center w-5 h-5 text-white bg-red-600 rounded-full'>
                  <X className='text-xs' weight='bold' />
                </span>
                <span className='text-sm font-medium text-red-500'>
                  We found startup with similar name!
                </span>
              </div>
            ) : (
              input &&
              input.length < 3 && (
                <div className='flex items-center space-x-2'>
                  <span className='text-sm font-medium text-zinc-500'>
                    Too short
                  </span>
                </div>
              )
            )}
            {searchResults.length > 0 && (
              <div className='mt-5 lg:mt-9'>
                <p className='pb-3 text-lg font-medium border-b border-white/20'>
                  We found similiar startup, is it yours?
                </p>
                <div className='relative mt-4'>
                  <div className='-my-4 divide-y divide-white/10 lg:max-h-[280px] overflow-y-auto'>
                    {searchResults.map((result, index) => (
                      <div
                        key={`result-${index}`}
                        className='flex items-start justify-between py-4 space-x-4'
                      >
                        <div className='flex items-center space-x-4'>
                          <div className='flex-shrink-0 w-[50px] lg:w-[60px] rounded-lg relative overflow-hidden aspect-square'>
                            {result.logo_url &&
                              result.logo_url.includes("http") && (
                                <Image
                                  src={result.logo_url}
                                  layout={"fill"}
                                  objectFit={"cover"}
                                  alt='Image'
                                />
                              )}
                          </div>
                          <div>
                            <p className='text-lg font-bold leading-tight text-white lg:text-xl'>
                              {result.name}
                            </p>
                            {result.website && (
                              <Link
                                legacyBehavior
                                href={result.website}
                                passHref
                              >
                                <a
                                  target='_blank'
                                  rel='noreferrer'
                                  className='mt-1.5 text-xs font-medium underline opacity-50'
                                >
                                  {result.website}
                                </a>
                              </Link>
                            )}
                          </div>
                        </div>
                        <Button
                          className='flex-shrink-0 mt-1'
                          size='sm'
                          onClick={
                            result.owner_id
                              ? () =>
                                router.push(
                                  `/startups/${result.slug}-${result.id}`
                                )
                              : () => handleSubscriptionStartupExist(result)
                          }
                        >
                          {result.owner_id ? "Review Now" : "Claim Now"}
                        </Button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className='hidden lg:block lg:w-[420px] mt-8 lg:mt-0'>
            {currencyCode !== "USD" && (
              <div className='flex items-center justify-center gap-2 mb-2 font-medium'>
                <p className='text-lg'>We have a special price for</p>
                <p className='text-2xl'>
                  {userLocation.country?.countryFlagEmoji}
                </p>
              </div>
            )}
            <div className='relative z-10 bg-white shadow-xl text-background rounded-2xl ring-1 ring-gray-900/10 xl:mb-10'>
              <div className='p-6 lg:p-8'>
                {!planSubscription?.is_startup_plan ? (
                  <div className='flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between lg:flex-col lg:items-stretch'>
                    <div className='flex flex-col gap-x-4'>
                      <p className='text-4xl font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-br from-yellow-1 to-red-1'>
                        {currencyCode === "USD" ? "$" : currencyCode + " "}
                        {convertStripeAmount(
                          priceData["Startup Registration"].unit_amount,
                          currencyCode
                        ).toLocaleString()}
                      </p>
                      <div className='mt-1 text-sm'>
                        {/* Payment frequency, update based on frequency toggle state */}
                        <p className='inline-block mr-1.5 text-gray-500'>
                          Billed annually
                        </p>
                        <span className='text-xs font-medium text-gray-500'>
                          ({currencyCode === "USD" ? "$" : currencyCode + " "}
                          {Math.round(
                            priceData["Startup Registration"].unit_amount / 1200
                          ).toLocaleString()}{" "}
                          monthly)
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <p className='font-semibold'>Your Plan: </p>
                    <p className='text-2xl font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-br from-yellow-1 to-red-1'>
                      Startup Registration
                    </p>
                  </div>
                )}
                <div className='flow-root pt-3 mt-3 border-t sm:mt-4 sm:pt-4 border-black/10'>
                  <ul
                    role='list'
                    className='-my-2 text-sm leading-6 text-gray-600 border-t divide-y lg:border-t-0 divide-gray-900/5 border-gray-900/5'
                  >
                    {startupBenefits.map((benefit, index) => (
                      <li
                        key={`benefit-${index}`}
                        className='flex py-2 gap-x-3'
                      >
                        <svg
                          className='flex-none w-5 h-6 text-orange-1'
                          viewBox='0 0 20 20'
                          fill='currentColor'
                          aria-hidden='true'
                        >
                          <path
                            fillRule='evenodd'
                            d='M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z'
                            clipRule='evenodd'
                          />
                        </svg>
                        {benefit}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export async function getServerSideProps({ req, query }) {
  // Import geolocation utility dynamically to avoid circular dependencies
  const { getGeolocationData, getUserIpFromRequest } = await import("@/utils/geolocation");

  const userIp = getUserIpFromRequest(req);

  // Fetch geolocation data using the shared utility (includes API key)
  const geoData = await getGeolocationData(userIp);

  // Create response object for compatibility with existing code
  const response = geoData.success ? { data: geoData } : null;

  const availablePrices =
    process.env.ENV !== "production" ? availablePricesDev : availablePricesProd;

  let priceData = {};
  let currencyCode = "USD";
  let priceIds = availablePrices["USD"];
  const codes = ["AED", "IDR", "JOD", "EGP", "SAR"];

  if (response?.data?.success && response?.data?.currency_code) {
    const currencyCodeFromApi = response.data.currency_code;
    if (codes.includes(currencyCodeFromApi)) {
      currencyCode = currencyCodeFromApi;
      priceIds = availablePrices[currencyCode];
    }
  }

  const stripe = require("stripe")(process.env.STRIPE_SECRET_KEY);

  for (const pKey in priceIds) {
    const stripePriceData = await stripe.prices.retrieve(priceIds[pKey]);
    priceData[pKey] = stripePriceData;
  }

  return {
    props: {
      userLocation: response?.data || null,
      currencyCode,
      priceData,
      priceIds,
      ip: userIp,
    },
  };
}

export default Pricing;
